import type { IContainerProps } from '~/components/utils/Container';
import type { IApiAppPlatform } from '~/lib/api/modules/Apps';
import { PipelineList } from '~/components/organisms/PipelineList';

export type IBuildProps = IContainerProps & {
  appId: string;
  platform: IApiAppPlatform;
};

export const Build: React.FC<IBuildProps> = (props) => {
  const { sx, appId, platform } = props;

  return <PipelineList sx={sx} appId={appId} platform={platform} />;
};
